import React from "react";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function InfoHint({ children, className = "", testid }) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            role="button"
            aria-label="More information"
            data-testid={testid || "info-hint"}
            className={`inline-flex items-center justify-center h-5 w-5 rounded-full border border-black/15 text-black/60 hover:text-[#5803FD] hover:border-[#5803FD] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(88,3,253,0.35)] transition-colors ${className}`}
          >
            <Info className="h-3 w-3" aria-hidden />
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-[280px] bg-white text-black border border-black/10 shadow-[0_10px_24px_rgba(0,0,0,0.10)] rounded-xl p-3 text-xs leading-relaxed"
        >
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function RequiredMark() {
  return (
    <span className="text-[#5803FD] font-semibold" aria-label="required" title="Required">
      *
    </span>
  );
}

export function OptionalLabel() {
  return (
    <span className="ml-1 text-[10px] uppercase tracking-wider text-black/45">optional</span>
  );
}

export function SectionDescription({ children }) {
  return (
    <p className="text-xs text-black/55 mt-0.5 mb-1 leading-relaxed">
      {children}
    </p>
  );
}